import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { registerStoryNameChoice } from "../lib/renameDuck";

const BTN = "w-full sm:w-auto rounded-full font-semibold";

// Mounted once (App). A rename hit a hand-edited story that still says the old name: update the text too, keep the
// text (the title follows either way), or cancel the rename. Esc / the close button / a tap outside = cancel.
export const StoryNameChoice = () => {
  const [ask, setAsk] = useState(null); // {old, new, resolve}
  const [open, setOpen] = useState(false);
  useEffect(() => registerStoryNameChoice((d) => new Promise((resolve) => { setAsk({ ...d, resolve }); setOpen(true); })), []);
  const done = (choice) => { setOpen(false); ask?.resolve(choice); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && done(null)}>
      <DialogContent data-testid="story-name-dialog" className="w-[calc(100%-2rem)] max-w-md rounded-3xl">
        <DialogHeader className="text-left">
          <DialogTitle className="font-heading text-lg">Also update the name in your story?</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-2">
              <p data-testid="story-name-dialog-change" className="flex flex-wrap items-center gap-2 text-base text-foreground">
                <span data-testid="story-name-dialog-old" className="font-semibold break-all">{ask?.old}</span>
                <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground" aria-label="to" />
                <span data-testid="story-name-dialog-new" className="font-semibold break-all">{ask?.new}</span>
              </p>
              <p className="text-sm">You wrote this story yourself. The story title follows the new name either way.</p>
            </div>
          </DialogDescription>
        </DialogHeader>
        {/* DOM order = focus/tab order (Update first); desktop shows it on the right */}
        <div className="flex flex-col gap-2 sm:flex-row-reverse sm:justify-start">
          <Button data-testid="story-name-update-btn" className={BTN} onClick={() => done("update")}>Update story too</Button>
          <Button data-testid="story-name-keep-btn" variant="outline" className={BTN} onClick={() => done("keep")}>Keep story text</Button>
          <Button data-testid="story-name-cancel-btn" variant="ghost" className={BTN} onClick={() => done(null)}>Cancel rename</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
